<template>
  <div class="row">
    <user-menu></user-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_READ','ROLE_USER_ADMIN')">

      <toast ref="toast"></toast>

      <button class="btn btn-info btn-sm m-2" @click="goNew" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')"><i class="fa fa-plus mr-1"></i>新規登録</button>
      <p v-if="departmentList.length === 0">まだデータがありません</p>
      <table v-else class="table table-bordered table-responsive">
            <thead class="thead-light">
              <tr>
                  <th>No.</th>
                  <th>部署名</th>
                  <th>作成日</th>
                  <th v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">削除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(result, index) in departmentList" :key="result.id">
                  <td class="noflap">{{index + 1}}</td>
                  <td class="noflap">
                    <a v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')" href="#" @click="goEdit(result.id)">{{result.departmentName}}</a>
                    <span v-else>{{result.departmentName}}</span>
                  </td>
                  <td class="noflap">{{result.createdAt}}</td>
                  <td v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">
                    <span>
                      <button type="button" class="btn btn-sm btn-outline-danger" @click="deleted(result.id)"><i class="fa fa-trash"></i>削除</button>
                    </span>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc !important;
}

</style>

<script>
import DepartmentAPI from '../../../api/department-api'
import CommonAPI from '../../../api/common-api'
import Toast from '../../Toast.vue'
import UserMenu from './UserMenu.vue'

export default {
  name: "department-list",
  components: {
    Toast,
    UserMenu
  },
  data() {
    return {
      departmentList: [],
      loginUser: {
        role: ''
      },
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
    },
  },
  mounted () {
    this.getDepartmentList()
  },
  methods: {
    getDepartmentList() {
      this.$root.$refs.loading.$data.show = true
      DepartmentAPI.getList()
            .then(res => {
              this.departmentList = res ? res : []
              this.$nextTick(function() {
                this.$root.$refs.loading.$data.show = false
              })
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
    },
    // 削除
    deleted (id) {
      if (window.confirm('削除してよろしいですか?')){
        this.$root.$refs.loading.$data.show = true
        DepartmentAPI.delete(id)
          .then(res => {
            this.getDepartmentList()
            this.$refs.toast.showToast("削除しました", 3000, false)
          })
          .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
          })
      }
    },
    goNew () {
        this.$router.push('/admin/department/new')
    },
    goEdit (id) {
        this.$router.push('/admin/department/edit/' + id)
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/user/DepartmentList.vue